export {ListNode} from './ListsSpecs';

export enum ListAction {
    ToBulletList = 'toBulletList',
    ToOrderedList = 'toOrderedList',
    SinkListItem = 'sinkListItem',
    LiftListItem = 'liftListItem',
}
